<template>
  <div class="notice-page">
    <!-- PC 端 -->
    <div class="notice-pc" v-show="isPC">
      <div class="notice-container">
        <h2 class="title-main">长江产业投资集团有限公司面向社会公开选聘集团中层管理人员公告</h2>
        <!-- 一、集团基本情况 -->
        <section class="notice-section">
          <h3>一、集团基本情况</h3>
          <div class="section-content">
            <div class="sub-title">（一）集团实力：应时代而生，因改革而强</div>
            <p>2022年1月，按照湖北省委、省政府决策部署，长江产业集团由省长投集团、省高投集团、长江产业基金管理公司、兴楚国资及宏泰集团优质产业板块战略性重组设立。集团注册资本336亿元，资产总额突破5000亿元，管理基金规模超7800亿元，在职员工近5万人。旗下实控二级子公司30家，构建起“8+4”公众公司矩阵——控股8家A股上市公司（广济药业、万润科技、双环科技、奥特佳、凯龙股份、台基股份、长江证券、襄阳轴承）及4家新三板挂牌企业（航特装备、光谷信息、中科水生、天华新材）。</p>

            <div class="sub-title">（二）战略格局：实体为体，资本与要素为翼</div>
            <p>集团坚定向实体型转型，形成“一体两翼”发展格局——实体产业为“体”，资本运营和要素保障为“两翼”。我们扛起省级国有资本运营主体、战略性新兴产业运营主体、科技创新与产业创新融合平台“两主体一平台”三大使命，独创“链长+链主+链投+链创”的“1+N+1+1”产业投资运营体系，推动资源配置从功能分类向行业聚集转变。重点布局汽车及高端制造、光电子信息、生命健康、现代化工、新能源、生态环保、新材料、北斗数字八大实体产业板块。锚定“2111”战略目标：到2030年，实现营业收入2000亿元、利润总额100亿元、资产总额10000亿元、参股基金规模突破10000亿元，综合实力跻身国内同类企业前列；到“十五五”末，全面实现“双一流”目标，即打造国内一流的产投平台和基金投资管理机构、国内一流的产业（控股）集团。致力成为产业整合的组织者、产业升级的引领者、资本价值的创造者、科产融合的促进者。</p>

            <div class="sub-title">（三）薪酬激励：对标头部，价值共创共享</div>
            <p>集团为中层管理者提供极具市场竞争力的薪酬体系。实行“岗位工资+绩效奖励+项目收益分成”市场化薪酬方案，辅以项目跟投、超额利润分享等中长期激励机制，将个人贡献与项目成果深度绑定。薪酬标准对标行业头部，搭建多职级、多薪档宽带薪酬体系，晋升通道透明通畅——以业绩论英雄，凭贡献定薪酬，搭建事业共创、风险共担、利益共享的事业合伙平台，让每一位价值创造者获得丰厚回报，与优秀人才共赢未来。</p>

            <div class="sub-title">（四）福利保障：全方位守护，为奋斗者护航</div>
            <p>除法定五险一金外，额外增设补充医疗保险和企业年金，构筑医疗、养老三重防护网；同步配套交通、餐饮、通讯等多项补贴，切实降低生活成本。年度免费体检、系统化职业赋能培训、节日慰问、生日福利、假期子女托管班等工会活动一应俱全；带薪年假、婚假、产假、看护假等充分保障员工权益，让每一位奋斗者心无旁骛、后顾无忧。</p>

            <div class="sub-title">（五）人才培养：精准赋能，激发人才活力</div>
            <p>集团聚焦中层管理人员持续成长，着力构建全方位、多层次、立体化培养体系。常态化举办“长江大讲堂”，邀请行业专家专题授课；选送优秀经营管理者赴清华大学、华中科技大学、武汉大学等一流高校深度研修，并赴行业标杆企业交流学习，持续拓宽战略视野、提升专业素养。建立“上挂央企总部、下派基层一线、外送省直机关”的政企纵向挂职体系；同时，积极推荐申报国家级、省级高端人才荣誉及重点人才计划，拥有自主职称评审权，让每一位有为者脱颖而出、尽展其才。</p>
            <p>我们诚邀有志于引领产业变革、成就事业理想的优秀管理者，加入长江产业集团，共赴“双一流”新征程！</p>
          </div>
        </section>

        <!-- 二、选聘计划 -->
        <section class="notice-section">
          <h3>二、选聘计划</h3>
          <div class="sub-title">（一）选聘范围</div>
          <div class="section-content">
            <p>面向集团外部符合条件的人员进行选聘。</p>
          </div>
          <div class="sub-title">（二）选聘岗位</div>
          <div class="section-content">
            <p><strong>1.集团中层正职</strong></p>
            <p>（1）深圳万润科技股份有限公司 总经理1名；</p>
            <p>（2）湖北长江北斗数字产业有限公司 总经理1名；</p>
            <p>（3）湖北省长江新动能私募基金管理有限公司 总经理1名。</p>

            <p><strong>2.集团中层副职</strong></p>
            <p>（1）深圳万润科技股份有限公司 总工程师1名；</p>
            <p>（2）湖北省长江新动能私募基金管理有限公司 副总经理1名；</p>
            <p>（3）湖北长江产业现代化工有限公司 副总经理1名；</p>
            <p>（4）湖北省生态环保有限公司 副总经理1名；</p>
            <p>（5）湖北省长江新材有限公司 副总经理1名；</p>
            <p>（6）湖北省新能源有限公司 副总经理1名；</p>
            <p>（7）湖北长江产业载体投资开发有限公司 副总经理1名；</p>
            <p>（8）湖北省人才发展集团有限公司 副总经理1名；</p>
            <p>（9）湖北长江北斗数字产业有限公司 副总经理2名；</p>
            <p>（10）湖北长江产融资本投资有限公司 副总经理1名；</p>
            <p>（11）湖北长江汽车产业投资有限公司 副总经理3名；</p>
            <p>（12）湖北省长江光电产业投资有限公司 副总经理2名；</p>
            <p>（13）湖北省长江医疗产业投资有限公司 副总经理2名。</p>
          </div>
          <div class="sub-title">（三）基本任职资格</div>
          <div class="section-content">
            <p>具体任职资格详见《集团公开选聘部分中层管理人员任职资格及岗位要求》（附件5）。</p>
          </div>
        </section>

        <!-- 三、简历投递 -->
        <section class="notice-section">
          <h3>三、简历投递</h3>
          <div class="section-content">
            <p>1.投递截止时间：2026年9月1日20点。</p>
            <p>2.投递方式：本次选聘仅接受系统报名，不接受其它报名方式，每人限报一个岗位。应聘者按要求填写报名信息，并将相关证明材料（包含但不限于学历学位证书、有效期内的学信网验证报告、身份证件、任职文件、职称及执业资格证书、能力和业绩证明材料、荣誉获奖证书等）上传至报名系统。</p>
            <p>3.投递通道：网申地址：<a href="https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026" target="_blank">https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026</a></p>
            <div class="qr-code-center">
              <img src="../../assets/tdrwm.png" alt="网申二维码" />
              <span class="qr-desc">扫码投递简历</span>
            </div>
            <p>4.投递资料：报名时须同时上传附件1至附件4的应聘承诺书等资格审查材料。附件1至附件5，请扫码查看下方二维码:</p>
            <div class="qr-code-center">
              <img src="../../assets/fjrwm.png" alt="资料下载二维码" />
              <span class="qr-desc">下载报名附件</span>
            </div>
          </div>
        </section>

        <!-- 四、招聘流程 -->
        <section class="notice-section">
          <h3>四、招聘流程</h3>
          <div class="section-content">
            <p>招聘流程为发布公告和报名、资格审查、履历分析、笔试、面试、组织考察（背景调查）、党委会审议、任前公示、聘用。</p>
          </div>
        </section>

        <!-- 五、管理方式 -->
        <section class="notice-section">
          <h3>五、管理方式</h3>
          <div class="section-content">
            <p>聘任后，按照省委、省政府进一步深化国企改革深化提升行动的决策部署，采用“人员管理市场化、业绩考核契约化、薪酬分配差异化、企业管理规范化、人员退出制度化”的五化原则进行管理与授权。</p>
          </div>
        </section>

        <!-- 六、监督管理 -->
        <section class="notice-section">
          <h3>六、监督管理</h3>
          <div class="section-content">
            <p>组织人事管理、出国（境）管理、保密管理、履职监督、责任追究。</p>
          </div>
        </section>

        <!-- 七、注意事项 -->
        <section class="notice-section">
          <h3>七、注意事项</h3>
          <div class="section-content">
            <p>1.请确保个人手机号码、电子邮件等联系方式填写准确，并保持通讯畅通，以便接收相关信息。</p>
            <p>2.应聘者需对个人信息的真实性、准确性和完整性负责，并按要求在简历投递系统中上传佐证资料。如存在弄虚作假等行为，一经查实，长江产业集团有权取消其应聘资格、解除相关协议约定。</p>
            <p>3.此次招聘过程中不收取报名费、手续费等任何费用，对发布虚假招聘信息的机构，长江产业集团保留追究法律责任的权利。请应聘者提高警惕，谨防上当受骗。</p>
            <p>4.此次招聘公告未尽事宜由长江产业集团人力资源部（党委组织部）负责解释。</p>
            <p class="contact-info">招聘咨询邮箱：cjcyhr@cjtouzi.com</p>
            <p class="contact-info">招聘咨询电话：周老师 027-87257940 18773319677</p>
          </div>
        </section>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="notice-mobile" v-show="!isPC">
      <div class="mobile-container">
        <h2 class="title-main">长江产业投资集团有限公司面向社会公开选聘集团中层管理人员公告</h2>
        <!-- 一、集团基本情况 -->
        <section class="notice-section mobile-section">
          <h3>一、集团基本情况</h3>
          <div class="section-content">
            <div class="sub-title">（一）集团实力：应时代而生，因改革而强</div>
            <p>2022年1月，按照湖北省委、省政府决策部署，长江产业集团由省长投集团、省高投集团、长江产业基金管理公司、兴楚国资及宏泰集团优质产业板块战略性重组设立。集团注册资本336亿元，资产总额突破5000亿元，管理基金规模超7800亿元，在职员工近5万人。旗下实控二级子公司30家，构建起“8+4”公众公司矩阵——控股8家A股上市公司（广济药业、万润科技、双环科技、奥特佳、凯龙股份、台基股份、长江证券、襄阳轴承）及4家新三板挂牌企业（航特装备、光谷信息、中科水生、天华新材）。</p>

            <div class="sub-title">（二）战略格局：实体为体，资本与要素为翼</div>
            <p>集团坚定向实体型转型，形成“一体两翼”发展格局——实体产业为“体”，资本运营和要素保障为“两翼”。我们扛起省级国有资本运营主体、战略性新兴产业运营主体、科技创新与产业创新融合平台“两主体一平台”三大使命，独创“链长+链主+链投+链创”的“1+N+1+1”产业投资运营体系，推动资源配置从功能分类向行业聚集转变。重点布局汽车及高端制造、光电子信息、生命健康、现代化工、新能源、生态环保、新材料、北斗数字八大实体产业板块。锚定“2111”战略目标：到2030年，实现营业收入2000亿元、利润总额100亿元、资产总额10000亿元、参股基金规模突破10000亿元，综合实力跻身国内同类企业前列；到“十五五”末，全面实现“双一流”目标，即打造国内一流的产投平台和基金投资管理机构、国内一流的产业（控股）集团。致力成为产业整合的组织者、产业升级的引领者、资本价值的创造者、科产融合的促进者。</p>

            <div class="sub-title">（三）薪酬激励：对标头部，价值共创共享</div>
            <p>集团为中层管理者提供极具市场竞争力的薪酬体系。实行“岗位工资+绩效奖励+项目收益分成”市场化薪酬方案，辅以项目跟投、超额利润分享等中长期激励机制，将个人贡献与项目成果深度绑定。薪酬标准对标行业头部，搭建多职级、多薪档宽带薪酬体系，晋升通道透明通畅——以业绩论英雄，凭贡献定薪酬，搭建事业共创、风险共担、利益共享的事业合伙平台，让每一位价值创造者获得丰厚回报，与优秀人才共赢未来。</p>

            <div class="sub-title">（四）福利保障：全方位守护，为奋斗者护航</div>
            <p>除法定五险一金外，额外增设补充医疗保险和企业年金，构筑医疗、养老三重防护网；同步配套交通、餐饮、通讯等多项补贴，切实降低生活成本。年度免费体检、系统化职业赋能培训、节日慰问、生日福利、假期子女托管班等工会活动一应俱全；带薪年假、婚假、产假、看护假等充分保障员工权益，让每一位奋斗者心无旁骛、后顾无忧。</p>

            <div class="sub-title">（五）人才培养：精准赋能，激发人才活力</div>
            <p>集团聚焦中层管理人员持续成长，着力构建全方位、多层次、立体化培养体系。常态化举办“长江大讲堂”，邀请行业专家专题授课；选送优秀经营管理者赴清华大学、华中科技大学、武汉大学等一流高校深度研修，并赴行业标杆企业交流学习，持续拓宽战略视野、提升专业素养。建立“上挂央企总部、下派基层一线、外送省直机关”的政企纵向挂职体系；同时，积极推荐申报国家级、省级高端人才荣誉及重点人才计划，拥有自主职称评审权，让每一位有为者脱颖而出、尽展其才。</p>
            <p>我们诚邀有志于引领产业变革、成就事业理想的优秀管理者，加入长江产业集团，共赴“双一流”新征程！</p>
          </div>
        </section>

        <!-- 二、选聘计划 -->
        <section class="notice-section mobile-section">
          <h3>二、选聘计划</h3>
          <div class="sub-title">（一）选聘范围</div>
          <div class="section-content">
            <p>面向集团外部符合条件的人员进行选聘。</p>
          </div>
          <div class="sub-title">（二）选聘岗位</div>
          <div class="section-content">
            <p><strong>1.集团中层正职</strong></p>
            <p>（1）深圳万润科技股份有限公司 总经理1名；</p>
            <p>（2）湖北长江北斗数字产业有限公司 总经理1名；</p>
            <p>（3）湖北省长江新动能私募基金管理有限公司 总经理1名。</p>

            <p><strong>2.集团中层副职</strong></p>
            <p>（1）深圳万润科技股份有限公司 总工程师1名；</p>
            <p>（2）湖北省长江新动能私募基金管理有限公司 副总经理1名；</p>
            <p>（3）湖北长江产业现代化工有限公司 副总经理1名；</p>
            <p>（4）湖北省生态环保有限公司 副总经理1名；</p>
            <p>（5）湖北省长江新材有限公司 副总经理1名；</p>
            <p>（6）湖北省新能源有限公司 副总经理1名；</p>
            <p>（7）湖北长江产业载体投资开发有限公司 副总经理1名；</p>
            <p>（8）湖北省人才发展集团有限公司 副总经理1名；</p>
            <p>（9）湖北长江北斗数字产业有限公司 副总经理2名；</p>
            <p>（10）湖北长江产融资本投资有限公司 副总经理1名；</p>
            <p>（11）湖北长江汽车产业投资有限公司 副总经理3名；</p>
            <p>（12）湖北省长江光电产业投资有限公司 副总经理2名；</p>
            <p>（13）湖北省长江医疗产业投资有限公司 副总经理2名。</p>
          </div>
          <div class="sub-title">（三）基本任职资格</div>
          <div class="section-content">
            <p>具体任职资格详见《集团公开选聘部分中层管理人员任职资格及岗位要求》（附件5）。</p>
          </div>
        </section>

        <!-- 三、简历投递 -->
        <section class="notice-section mobile-section">
          <h3>三、简历投递</h3>
          <div class="section-content">
            <p>1.投递截止时间：2026年9月1日20点。</p>
            <p>2.投递方式：本次选聘仅接受系统报名，不接受其它报名方式，每人限报一个岗位。应聘者按要求填写报名信息，并将相关证明材料（包含但不限于学历学位证书、有效期内的学信网验证报告、身份证件、任职文件、职称及执业资格证书、能力和业绩证明材料、荣誉获奖证书等）上传至报名系统。</p>
            <p>3.投递通道：网申地址：<a href="https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026" target="_blank">https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026</a></p>
            <div class="qr-code-center">
              <img src="../../assets/tdrwm.png" alt="网申二维码" />
              <span class="qr-desc">扫码投递简历</span>
            </div>
            <p>4.投递资料：报名时须同时上传附件1至附件4的应聘承诺书等资格审查材料。附件1至附件5，请扫码查看下方二维码:</p>
            <div class="qr-code-center">
              <img src="../../assets/fjrwm.png" alt="资料下载二维码" />
              <span class="qr-desc">下载报名附件</span>
            </div>
          </div>
        </section>

        <!-- 四、招聘流程 -->
        <section class="notice-section mobile-section">
          <h3>四、招聘流程</h3>
          <div class="section-content">
            <p>招聘流程为发布公告和报名、资格审查、履历分析、笔试、面试、组织考察（背景调查）、党委会审议、任前公示、聘用。</p>
          </div>
        </section>

        <!-- 五、管理方式 -->
        <section class="notice-section mobile-section">
          <h3>五、管理方式</h3>
          <div class="section-content">
            <p>聘任后，按照省委、省政府进一步深化国企改革深化提升行动的决策部署，采用“人员管理市场化、业绩考核契约化、薪酬分配差异化、企业管理规范化、人员退出制度化”的五化原则进行管理与授权。</p>
          </div>
        </section>

        <!-- 六、监督管理 -->
        <section class="notice-section mobile-section">
          <h3>六、监督管理</h3>
          <div class="section-content">
            <p>组织人事管理、出国（境）管理、保密管理、履职监督、责任追究。</p>
          </div>
        </section>

        <!-- 七、注意事项 -->
        <section class="notice-section mobile-section">
          <h3>七、注意事项</h3>
          <div class="section-content">
            <p>1.请确保个人手机号码、电子邮件等联系方式填写准确，并保持通讯畅通，以便接收相关信息。</p>
            <p>2.应聘者需对个人信息的真实性、准确性和完整性负责，并按要求在简历投递系统中上传佐证资料。如存在弄虚作假等行为，一经查实，长江产业集团有权取消其应聘资格、解除相关协议约定。</p>
            <p>3.此次招聘过程中不收取报名费、手续费等任何费用，对发布虚假招聘信息的机构，长江产业集团保留追究法律责任的权利。请应聘者提高警惕，谨防上当受骗。</p>
            <p>4.此次招聘公告未尽事宜由长江产业集团人力资源部（党委组织部）负责解释。</p>
            <p class="contact-info">招聘咨询邮箱：cjcyhr@cjtouzi.com</p>
            <p class="contact-info">招聘咨询电话：周老师 027-87257940 18773319677</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "TabNotice",
  data() {
    return {
      isPC: true,
    };
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.isPC = window.innerWidth >= 992;
    },
  },
};
</script>
  
<style scoped lang="less">
.notice-page {
  width: 100%;
  padding: 20px 0;
  background-color: #f9f9f9;

  .title-main {
    text-align: center;
    font-size: 24px;
    color: #069;
    font-weight: 700;
    margin: 0 0 32px;
    line-height: 1.6;
  }

  .sub-title {
    font-weight: 600;
    color: #005580;
    margin: 14px 0 8px;
    font-size: 16px;
  }

  .contact-info {
    text-indent: 0 !important;
    padding-left: 2em;
  }

  .qr-code-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 0;
    img {
      width: 220px;
      height: 220px;
      object-fit: contain;
      border: 1px solid #eee;
      border-radius: 4px;
    }
    .qr-desc {
      margin-top: 8px;
      font-size: 14px;
      color: #666;
    }
  }
}

/* PC 端 */
.notice-pc {
  .notice-container {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding: 40px 48px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .notice-section {
      margin-bottom: 40px;
      &:last-child {
        margin-bottom: 0;
      }

      h3 {
        font-size: 20px;
        color: #069;
        margin: 0 0 16px;
        font-weight: 600;
        display: flex;
        align-items: center;
        &::after {
          content: "";
          flex: 1;
          height: 1px;
          background: #e6eef2;
          margin-left: 16px;
        }
      }

      .section-content {
        line-height: 1.85;
        font-size: 15px;
        color: #333;
        text-align: justify;
        p {
          margin-bottom: 14px;
          text-indent: 2em;
          &:last-child {
            margin-bottom: 0;
          }
          a {
            color: #006699;
          }
        }
      }
    }
  }
}

/* 移动端 */
.notice-mobile {
  .mobile-container {
    width: 95%;
    margin: 0 auto;
    background: #fff;
    padding: 24px 18px;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    .title-main {
      font-size: 18px;
      margin-bottom: 20px;
    }

    .mobile-section {
      margin-bottom: 32px;
      &:last-child {
        margin-bottom: 0;
      }

      h3 {
        font-size: 17px;
        color: #006699;
        margin: 0 0 12px;
        font-weight: 600;
        display: flex;
        align-items: center;
        &::after {
          content: "";
          flex: 1;
          height: 1px;
          background: #e6eef2;
          margin-left: 12px;
        }
      }

      .sub-title {
        font-size: 15px;
        margin: 10px 0 6px;
      }

      .section-content {
        line-height: 1.8;
        font-size: 14px;
        color: #333;
        text-align: justify;
        p {
          margin-bottom: 12px;
          text-indent: 2em;
          &:last-child {
            margin-bottom: 0;
          }
          a {
            color: #006699;
            word-break: break-all;
          }
        }
      }

      .qr-code-center img {
        width: 180px;
        height: 180px;
      }
    }
  }
}

/* 设备显隐控制 */
@media screen and (max-width: 991px) {
  .notice-p {
    display: none !important;
  }
}
@media screen and (min-width: 992px) {
  .notice-mobile {
    display: none !important;
  }
}
</style>